export const pathToRegex = (path) => {
  // Replace :paramName with a regex pattern that matches numbers (\d+) or other patterns
  const regexString = path.replace(/:[^\s/]+/g, '([^/]+)');

  return new RegExp(`^${regexString}$`);
};
